import React from "react";
import Header1 from "./Header1";
import Header2 from "./Header2";
import Body27 from "./Body27";
import Footer1 from "./Footer1";
import Footer2 from "./Footer2";


function PageProjektyBody27() {

  return (
    <div>
      <Header1/>
      <Header2/>
      <Body27/>
      <Footer1/>
      <Footer2/>
    </div>
  );
}

export default PageProjektyBody27;
